module.exports = __webpack_public_path__ + "static/media/caret-square-down.d6629087.svg";